import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import LoaderModal from "../../../../../../components/LoaderModal/LoaderModal";
import { useUserState } from "../../../../../../context/UserContext";
import { formatDate } from "../../../../../PojedinaObavijest/utils";
import styles from "../../../../../polazniciPregled/PolazniciPregled.module.css";
import { fetchUser } from "./utils";

function UserInfo({ evidentionUserID, course }) {
  const [userData, setUserData] = useState(null);
  const { accessToken } = useUserState();
  const [group, setGroup] = useState(null);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchUser(
      evidentionUserID,
      setLoading,
      accessToken,
      setUserData,
      course,
      setGroup
    );
  }, [evidentionUserID, accessToken, course]);

  return (
    <>
      {loading ? (
        <LoaderModal />
      ) : (
        <div className={styles.columns}>
          <div className={styles["left-column"]}>
            <table>
              <tbody>
                <tr>
                  <td className={styles["span"]}>Grupa:</td>
                  <td
                    style={{ cursor: "pointer", textDecoration: "underline" }}
                    className={styles["spanData"]}
                    onClick={() => navigate(`/grupe/${group.id}`)}
                  >
                    {group?.name}
                  </td>
                </tr>
                <tr>
                  <td className={styles["span"]}>Ime i prezime:</td>
                  <td className={styles["spanData"]}>
                    {userData?.data?.userDetails?.firstName}{" "}
                    {userData?.data?.userDetails?.lastName}
                  </td>
                </tr>
                <tr>
                  <td className={styles["span"]}>Datum rođenja:</td>
                  <td className={styles["spanData"]}>
                    {
                      formatDate(userData?.data?.userDetails?.dateOfBirth)
                        .formattedDate
                    }{" "}
                  </td>
                </tr>
                <tr>
                  <td className={styles["span"]}>Spol</td>
                  <td className={styles["spanData"]}>
                    {userData?.data?.userDetails?.gender}
                  </td>
                </tr>
                <tr>
                  <td className={styles["span"]}>Stručna sprema:</td>
                  <td className={styles["spanData"]}>
                    {userData?.data?.userDetails?.qualification}
                  </td>
                </tr>
                <tr>
                  <td className={styles["span"]}>Grad pohađanja OR-a:</td>
                  <td className={styles["spanData"]}>
                    {userData?.data?.userDetails?.programCity}
                  </td>
                </tr>
                <tr>
                  <td className={styles["span"]}>Grad stanovanja:</td>
                  <td className={styles["spanData"]}>
                    {userData?.data?.userDetails?.city}
                  </td>
                </tr>
                <tr>
                  <td className={styles["span"]}>Email:</td>
                  <td className={styles["spanData"]}>
                    {userData?.data?.userDetails?.emailAddress}
                  </td>
                </tr>
                <tr>
                  <td className={styles["span"]}>Država stanovanja:</td>
                  <td className={styles["spanData"]}>
                    {userData?.data?.userDetails?.country}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      )}
    </>
  );
}

export default UserInfo;
